export default __webpack_public_path__ + "static/media/minibox_dragon.1d1bb5c1.png";